export enum OutputDataUrl {
  OUTPUT_DATA_GROUP_PROCESSING_STATES = '/output-data/group-processing-states{?page,size,sort,name,userFollowedDataObjectGroups,valueDate,onlyLastValueDate,dueDateTime,domainId*,frequencyId*,outputTypeId*,includeMixedOutputType,processingStateCode*,username,sourceCode,outputCode}',
  OUTPUT_DATA_GROUP_PROCESSING_STATES_REFRESH = '/output-data/group-processing-states/refresh{?ids*}',
  OUTPUT_DATA_CALCULATION = '/output-data/calculations',
  OUTPUT_DATA_CALCULATION_ERRORS = '/output-data/calculation-errors{?groupId,outputIds*,valueDate}',
  OUTPUT_DATA_VALIDATION = '/output-data/validations',
  OUTPUT_DATA_CONFIRMATIONS_QUERY = '/output-data/confirmations{?groupId,valueDate}',
  OUTPUT_DATA_CONFIRMATIONS = '/output-data/confirmations',
  OUTPUT_DATA_DELETION = '/output-data/deletions',
  OUTPUT_DESCRIPTION_PROCESSING_STATES = '/output-data/description-processing-states{?groupId,valueDate}',
  TEST_VALIDATIONS = '/output-data/test-validations{/dagRunId}',
  TEST_CALCULATIONS = '/output-data/test-calculations{/dagRunId}',
  TEST_CALCULATIONS_OUTPUT_DATA = '/output-data/test-calculations/{dagRunId}/output-data{?page,size,sort,filterParams*}',
  TEST_CALCULATIONS_EXCEL = '/output-data/test-calculations/{dagRunId}/excel',
  OUTPUT_DATA_TIMESERIES_CALCULATIONS = '/output-data/time-series-calculations',
  OUTPUT_DATA_TIMESERIES_VALIDATIONS = '/output-data/time-series-validations',
  OUTPUT_DATA_TIMESERIES_CONFIRMATIONS = '/output-data/time-series-confirmations',
}
